<template>
  <div>
    <CompanyHeader :img_header="header_image" header="ตั้งค่าข้อมูลบริษัท" link_back="managewebsite"/>
    <MenuCompany/>
    <Contact_information/>
  </div>
</template>

<script>
import CompanyHeader from "@/components/admin/manage_website/company_setting/menu_company/CompanyHeader";
import HeaderImage from "@/assets/process.png";
import MenuCompany from "@/components/admin/manage_website/company_setting/menu_company/MenuCompany";
import Contact_information from "@/components/admin/manage_website/company_setting/Contact_information";
export default {
  name: "ContactInformation",
  components: {
    Contact_information,
    MenuCompany,
    CompanyHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
